/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// for translation
import { useTranslation, Trans } from "react-i18next";

/* -------------------------- required imports for API Call -------------------------- */
// import Gateway for API fetch call
import { getData, postData } from "utils/Gateway";

// import all URLs from url_helper
import * as url from "helpers/url_helper";
/* ----------------------------------------------------------------------------------- */

const ForwardModal = (props) => {
  // getting the forwarded message via props here
  let forwardedMessageId = props.messageId;

  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  //console.log("forward modal message id ----->", forwardedMessageId);

  // accessing the user's token here
  const token = localStorage.getItem("token");

  // initial useState to hold all the selected users
  const [selectedPersons, setSelectedPersons] = useState([]);

  // initial state for all contact list
  const [allcontacts, setAllcontacts] = useState([]);

  // useState to hold value from search field
  const [searchName, setSearchName] = useState("");

  // any error message
  const [forwardNotification, setForwardNotification] = useState("");

  // function to search value from JSON
  function filterByName(name) {
    setSearchName(name);
  }

  // API call to fetch conversations list
  const getAllContacts = async () => {
    let requestURL = url.API_BaseUrl + url.API_ALL_CONTACTS + `?token=${token}`;

    // console.log("contact forward modal url -----> ", requestURL);

    try {
      const response = await getData(requestURL);

      //console.log("Received response forward Modal is ------> ", response);

      if (response.status) {
        // console.log("response is----->", response.data);
        setAllcontacts(response.data);
      } else {
        // console.log("Some error occurred!");
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const selectedForwardingGroup = (memberid) => {
    let prevPersonIds = selectedPersons;

    if (prevPersonIds.includes(memberid)) {
      // exist in array, thus remove
      let key = prevPersonIds.indexOf(memberid);
      prevPersonIds.splice(key, 1);
    } else {
      // not exist in array, thus add
      prevPersonIds.push(memberid);
    }

    setSelectedPersons(prevPersonIds);

    // toggle class based on id
    var membersBlock = document.getElementById(
      "checkboxforwardmodal-" + memberid
    );
    //console.log("member block------>", membersBlock);
    membersBlock.classList.toggle("blue_bullet");

    // unset if any error previous
    setForwardNotification("");

    //console.log("person----->", selectedPersons);
  };

  // action to forward message -----------------------------------------------
  const forwardMessageHandler = async () => {
    let uid = "";

    selectedPersons.map((data, index) => {
      uid += `&uids[]=${data}`;
    });

    // console.log("The UIDs are --------> ", uid);

    // check condition whether selected person more than two or not
    if (selectedPersons.length >= 1) {
      let requestURL =
        url.API_BaseUrl +
        url.API_FORWARD_MESSAGE +
        `?token=${token}` +
        `&chatid=${forwardedMessageId}` +
        `${uid}`;

      //console.log("Forward Modal URL --------> ", requestURL);
      try {
        setForwardNotification("Forwarding message to selected contact");

        const response = await getData(requestURL);

        //console.log("Received response in forward modal ------> ", response);

        if (response.status) {
          //console.log("successfully submitted");
        } else {
          setForwardNotification("sorry, the request could not be completed");
        }
      } catch (error) {
        //console.log(error);
      }

      // reset all after the operation
      resetForward();
    } else {
      setForwardNotification("You forgot to select contact?");
    }
  };

  // Reset the forward activity and remove class from seleceted contacts
  const resetForward = () => {
    // select the modal to hide
    var forwardModal = document.querySelector("#forward_mdl");
    var modal = bootstrap.Modal.getInstance(forwardModal);

    // remove selected classes
    var resetBlock = document.getElementsByClassName("forwardToContact");
    for (var i = 0; i < resetBlock.length; i++) {
      resetBlock[i].classList.remove("blue_bullet");
    }
    // reset selected person useState
    setSelectedPersons([]);
    // reset notification if any
    setForwardNotification("");
    // hide modal
    modal.hide();
  };

  // --------- useEffect -----------
  useEffect(() => {
    //console.log('in ForwardModal UseEffect');
    getAllContacts();
  }, []);

  return (
    <>
      <div className="chat_modalbx">
        <div className="modal fade" id="forward_mdl">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              {/* ---------- Modal Header starts here ---------- */}
              <div className="modal-header mdl_hdng">
                <h5 className="modal-title">{t("Forward to")} </h5>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={resetForward}
                >
                  <span className="material-icons-round">close </span>
                </button>
              </div>
              {/* ---------- Modal Header ends here ---------- */}

              {/* ---------- Modal Body starts here ---------- */}
              <div className="modal-body">
                {/* ---------- Modal search bar ---------- */}
                <div className="group_srchfill">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search for people"
                    value={searchName}
                    onChange={(e) => filterByName(e.target.value)}
                  />
                </div>
                {/* ---------- Modal search bar ends here ---------- */}

                {/* ---------- Modal list section ---------- */}
                <div className="group_innrScroll">
                  <div className="text-center text-primary text-weight-bold">
                    {forwardNotification}
                  </div>
                  {allcontacts.map((data) => (
                    <div
                      className={`chat_usrRow ${
                        data.label
                          .toLowerCase()
                          .includes(searchName.toLowerCase())
                          ? ""
                          : "hide"
                      }`}
                      key={data.id}
                    >
                      <Link
                        to="#"
                        key={data.id}
                        onClick={() => {
                          selectedForwardingGroup(data.uid);
                        }}
                      >
                        <div className="usr_lftPnl">
                          {data.image != null ? (
                            <div className="chatting_user">
                              <img src={data.image} alt="UserProfile" />
                            </div>
                          ) : (
                            <div className="chatting_user">
                              <span className="material-icons-round">
                                person
                              </span>
                            </div>
                          )}

                          <div className="user_name">
                            <h3>
                              {data.name} {data.surname}
                            </h3>
                          </div>
                        </div>
                        <div
                          className="members_check forwardToContact"
                          id={"checkboxforwardmodal-" + data.uid}
                        >
                          <span></span>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
                {/* ---------- Modal list section ends ---------- */}

                {/* ---------------- Modal button section from here ---------------- */}
                <div className="group_btnOuter">
                  <ul>
                    <li className="w_100">
                      <Link
                        to="#"
                        className="ornage_btn"
                        onClick={forwardMessageHandler}
                      >
                        <i className="material-icons-round"> check_circle </i>
                        <span>Done</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* ---------- Modal Body ends here ---------- */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForwardModal;
